import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { getFxEnabledRoles } from 'common/utils/user';

export const routes = [
    {
        component: lazy(() => import('module/studyreports/studyreports.page')),
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.ClinicalTrialLead,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.BlindedStudyManager,
            RoleVariantEnum.AdminReadOnly,
            ...getFxEnabledRoles(),
        ],
        path: '/studyreports/:studyId/:reportInfo/:dashboardId?',
    },
];
